import React, { Component } from 'react';
import { Row, Col } from 'antd';

import './Intro.css'

import sm from './imgs/img_apps_feature_sm.svg';
import cm from './imgs/img_apps_feature_cm.svg';
import td from './imgs/img_apps_feature_td.svg';

class Intro extends Component {
  render() {
    return (
      <div className="Intro">
        <Row gutter={32}>
          <Col span={8}>
            <img src={sm} alt="Similarity Search"/>
          </Col>
          <Col span={16}>
            <span className="SmartRec">
              <h3>Similarity Search</h3>
              <p>Inside the Qbates app, click on the “Q” icon to search similar products. </p>
            </span>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <img src={cm} alt="Cashback management"/>
          </Col>
          <Col span={16}>
            <span className="SmartRec">
              <h3>Know Cashback Before You Buy</h3>
              <p>We will make calculation to estimate your earnings.</p>
            </span>
          </Col>
          <Col span={8} style={{ paddingLeft: '5%' }} className="Cashback">
            <img src={cm} alt="Cashback management" style={{paddingTop: '20px'}}/>
          </Col>
        </Row>
        <Row>
          <Col span={8} style={{ padding:'0 16px' }}>
            <img src={td} alt="Transactions Detail"/>
          </Col>
          <Col span={16} style={{ padding:'0 16px' }}>
            <span style={{paddingTop: '30px'}}>
              <h3>Transactions Detail</h3>
              <p>
                We will provide you with comprehensive transaction details for the current month. You will be able to see how many purchases you’ve made, how many returns you’ve hit and how much you’ve earned.
              </p>
            </span>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Intro;


// WEBPACK FOOTER //
// ./src/Containers/App/components/Intro.js